import { createFileRoute } from '@tanstack/react-router';

import { ApprovalsLayout } from '@/features/approvals/approvals-layout';

export const Route = createFileRoute('/__authenticated/approvals')({
	staticData: { titleKey: 'navigation.approvals' },
	component: ApprovalsLayout,
});
